/**
 * Facebook Pixel Service
 * Gestisce il tracking degli eventi per Facebook Ads
 */

class FacebookPixelService {
  /**
   * Verifica se fbq è disponibile
   */
  static isAvailable() {
    return typeof window !== 'undefined' && typeof window.fbq === 'function';
  }

  /**
   * Track PageView - già gestito automaticamente dallo script base
   */
  static trackPageView() {
    if (this.isAvailable()) {
      window.fbq('track', 'PageView');
      console.log('📊 FB Pixel: PageView tracked');
    }
  }

  /**
   * Track ViewContent - Visualizzazione prodotto/contenuto
   * @param {Object} params - Parametri del contenuto visualizzato
   */
  static trackViewContent(params = {}) {
    if (this.isAvailable()) {
      const data = {
        content_name: params.content_name || params.name,
        content_category: params.content_category || params.category,
        content_type: params.content_type || 'product',
        value: params.value || params.price || 0,
        currency: params.currency || 'EUR',
        content_ids: params.content_ids || [params.id]
      };

      window.fbq('track', 'ViewContent', data);
      console.log('📊 FB Pixel: ViewContent tracked', data);
    }
  }

  /**
   * Track AddToCart - Aggiunta al carrello
   * @param {Object} params - Parametri del prodotto aggiunto
   */
  static trackAddToCart(params = {}) {
    if (this.isAvailable()) {
      const data = {
        content_name: params.content_name || params.name,
        content_category: params.content_category || params.category,
        content_type: params.content_type || 'product',
        value: params.value || params.price || 0,
        currency: params.currency || 'EUR',
        content_ids: params.content_ids || [params.id],
        num_items: params.quantity || 1
      };

      window.fbq('track', 'AddToCart', data);
      console.log('📊 FB Pixel: AddToCart tracked', data);
    }
  }

  /**
   * Track InitiateCheckout - Inizio processo di checkout
   * @param {Object} params - Parametri del checkout
   */
  static trackInitiateCheckout(params = {}) {
    if (this.isAvailable()) {
      const data = {
        value: params.value || params.total || 0,
        currency: params.currency || 'EUR',
        num_items: params.num_items || params.items?.length || 0,
        content_ids: params.content_ids || []
      };

      window.fbq('track', 'InitiateCheckout', data);
      console.log('📊 FB Pixel: InitiateCheckout tracked', data);
    }
  }

  /**
   * Track Purchase - Acquisto completato (EVENTO PIÙ IMPORTANTE!)
   * @param {Object} params - Parametri dell'ordine completato
   */
  static trackPurchase(params = {}) {
    if (this.isAvailable()) {
      const data = {
        value: params.value || params.total || 0,
        currency: params.currency || 'EUR',
        content_type: params.content_type || 'product',
        content_ids: params.content_ids || [],
        num_items: params.num_items || params.items?.length || 0,
        // Parametri opzionali ma utili
        order_id: params.order_id || params.orderNumber,
        predicted_ltv: params.predicted_ltv // Lifetime value predetto (opzionale)
      };

      window.fbq('track', 'Purchase', data);
      console.log('📊 FB Pixel: Purchase tracked', data);
    }
  }

  /**
   * Track Lead - Form contatti compilato
   * @param {Object} params - Parametri del lead
   */
  static trackLead(params = {}) {
    if (this.isAvailable()) {
      const data = {
        content_name: params.content_name || 'Contact Form',
        content_category: params.content_category || 'Lead',
        value: params.value || 0,
        currency: params.currency || 'EUR'
      };

      window.fbq('track', 'Lead', data);
      console.log('📊 FB Pixel: Lead tracked', data);
    }
  }

  /**
   * Track Custom Event - Evento personalizzato
   * @param {string} eventName - Nome dell'evento custom
   * @param {Object} params - Parametri dell'evento
   */
  static trackCustomEvent(eventName, params = {}) {
    if (this.isAvailable()) {
      window.fbq('trackCustom', eventName, params);
      console.log(`📊 FB Pixel: Custom event "${eventName}" tracked`, params);
    }
  }

  /**
   * Eventi Custom Specifici per IlTuoAmaro
   */

  /**
   * Track quando un utente completa uno step del Builder
   */
  static trackBuilderStep(stepNumber, stepName, data = {}) {
    this.trackCustomEvent('BuilderStepCompleted', {
      step_number: stepNumber,
      step_name: stepName,
      ...data
    });
  }

  /**
   * Track generazione etichetta AI
   */
  static trackAILabelGenerated(data = {}) {
    this.trackCustomEvent('AILabelGenerated', {
      style: data.style,
      product_name: data.productName,
      ...data
    });
  }

  /**
   * Track generazione anteprima 3D
   */
  static track3DPreviewGenerated(data = {}) {
    this.trackCustomEvent('3DPreviewGenerated', {
      product_type: data.productType,
      ...data
    });
  }
}

export default FacebookPixelService;
